import Phaser from "phaser";

import { ArenaCatalogScene } from "./ArenaCatalogScene";

export type ArenaCatalogRuntime = {
  game: Phaser.Game;
  scene: ArenaCatalogScene;
  ready: Promise<void>;
  resize(width: number, height: number): void;
  setReducedMotion(reducedMotion: boolean): void;
  destroy(): void;
};

export function createArenaCatalogGame(parent: HTMLElement, reducedMotion: boolean): ArenaCatalogRuntime {
  let resolveReady: () => void = () => undefined;
  const ready = new Promise<void>((resolve) => {
    resolveReady = resolve;
  });
  const scene = new ArenaCatalogScene({ onReady: resolveReady }, reducedMotion);
  const game = new Phaser.Game({
    type: Phaser.CANVAS,
    parent,
    width: parent.clientWidth || 360,
    height: parent.clientHeight || 800,
    transparent: true,
    antialias: true,
    render: { antialias: true, pixelArt: false, roundPixels: false },
    scale: { mode: Phaser.Scale.NONE, autoCenter: Phaser.Scale.NO_CENTER },
    scene: [scene],
    banner: false,
  });
  const canvas = parent.querySelector("canvas");
  if (canvas !== null) {
    canvas.style.pointerEvents = "none";
    canvas.setAttribute("aria-hidden", "true");
  }
  return {
    game,
    scene,
    ready,
    resize(width, height): void {
      game.scale.resize(Math.round(width), Math.round(height));
    },
    setReducedMotion(next): void {
      scene.setReducedMotion(next);
    },
    destroy(): void {
      game.destroy(true);
    },
  };
}
